<template>
  <!--@mousemove="handleMouseMove" @mouseleave="resetZoom"-->
  <section>
    <output v-show="isDebug">{{
      JSON.stringify(selectedVolumeLesionTrauma)
    }}</output>

    <svg
      ref="svg"
      width="792"
      height="720"
      viewBox="0 0 792 720"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <rect width="792" height="720" :style="zoomStyle" fill="url(#pattern5)" />
      <g :style="zoomStyle">
        <g id="brainTrauma1">
          <path
            @click="selected('CisterneNormali')"
            :class="
              selectedVolumeLesionTrauma.includes('CisterneNormali')
                ? 'selected'
                : ''
            "
            d="M210 230
                    L450 230 
                    L450 90
                    L210 90
                    Z"
            fill="#a1a25e"
            stroke="black"
          />
        </g>
        <g id="brainTrauma2">
          <path
            @click="selected('CisterneDistorte')"
            :class="
              selectedVolumeLesionTrauma.includes('CisterneDistorte')
                ? 'selected'
                : ''
            "
            d="M220 350
                    L335 350 
                    L335 230
                    L220 230
                    "
            fill="#a1a25e"
            stroke="black"
          />
        </g>
        <g id="brainTrauma3">
          <path
            @click="selected('CisterneCompresse')"
            :class="
              selectedVolumeLesionTrauma.includes('CisterneCompresse')
                ? 'selected'
                : ''
            "
            d="M220 485
                    L580 485 
                    L580 350
                    L220 350
                    "
            fill="#a1a25e"
            stroke="black"
          />
        </g>
        <g id="brainTrauma3">
          <path
            @click="selected('CisterneAssenti')"
            :class="
              selectedVolumeLesionTrauma.includes('CisterneAssenti')
                ? 'selected'
                : ''
            "
            d="M220 625
                    L580 625 
                    L580 485
                    L220 485
                    "
            fill="#a1a25e"
            stroke="black"
          />
        </g>
      </g>
    </svg>
  </section>
</template>

<script setup lang="ts">
import {
  Contexts,
  CurrentCaseServiceInterface,
  getContainer,
  getContext,
  Helpers,
  NamedBindings,
  ApplicationEvents,
  Version,
  CoreConfiguration,
} from '@dandelion/core';
import { onBeforeMount, ref, Ref } from 'vue';
import { isEqual } from 'lodash';

const props = defineProps<{
  context: string;
  fullName: string;
  id: string;
}>();

const coreConfiguration = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CoreConfiguration
) as CoreConfiguration;
const currentCaseService = getContainer(Contexts.DEFAULT).get(
  NamedBindings.CurrentCaseService
) as CurrentCaseServiceInterface;

const isDebug = coreConfiguration.debug;
const selectedVolumeLesionTrauma = ref<Array<string>>([]);
const zoomed = ref(false);
const zoomLevel = ref(2); // Puoi modificare questo valore per cambiare il livello di zoom
const zoomStyle = ref({});

async function selected(selected: string) {
  const model = (await useCurrentContext(props!.context)).model;

  // Imposta il valore selezionato come unico elemento dell'array
  selectedVolumeLesionTrauma.value = [selected];

  // Aggiorna il modello
  Helpers.setObjByPath(props.fullName, model, selectedVolumeLesionTrauma.value);
}

onBeforeMount(async () => {
  const model = (await useCurrentContext(props!.context)).model;
  const selectedVolumeLesionTraumaFromModel = Helpers.getObjByPath(
    props.fullName,
    model
  );
  if (!selectedVolumeLesionTraumaFromModel) return;
  selectedVolumeLesionTrauma.value = selectedVolumeLesionTraumaFromModel ?? [];
});

async function useCurrentContext(context = Contexts.DEFAULT) {
  let crfVersions: Readonly<Ref<ReadonlyMap<string, Version>>> = ref(new Map());
  try {
    crfVersions = ref(currentCaseService.getCrfVersions());
  } catch (e) {
    // TODO: maybe remove error thrown, there are cases when no version is available
    // e.g. the context is not set, no current patient etc.
  }

  const model = await currentCaseService.getModel();
  const keyForReRender = ref(0);

  getContext(context).addEventListener(
    ApplicationEvents.CaseOpenedForEditing,
    async () => {
      const currentCrfVersions = currentCaseService.getCrfVersions();
      if (!isEqual(currentCrfVersions, crfVersions)) {
        crfVersions = currentCrfVersions;
      }
      keyForReRender.value = keyForReRender.value + 1;
    }
  );
  return { keyForReRender, crfVersions, model };
}

// Funzione di zoom
function handleMouseMove(event: MouseEvent) {
  const svg = (event.currentTarget as HTMLElement).querySelector('svg');
  if (!svg) return;

  const { clientX, clientY } = event;
  const svgRect = svg.getBoundingClientRect();
  const svgX = clientX - svgRect.left;
  const svgY = clientY - svgRect.top;

  // Calcolare la trasformazione per il layer di zoom
  zoomStyle.value = {
    transform: `translate(${-svgX * (zoomLevel.value - 1)}px, ${-svgY * (zoomLevel.value - 1)}px) scale(${zoomLevel.value})`,
    transformOrigin: `${svgX}px ${svgY}px`,
  };
}

function resetZoom() {
  zoomed.value = false;
  zoomStyle.value = {};
}
</script>

<style scoped>
path {
  opacity: 0.15;
}

path:hover {
  cursor: pointer;
  opacity: 0.3;
}

.selected {
  cursor: pointer;
  opacity: 0.8 !important;
}
</style>
